import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { useContractBalance } from 'src/app/v1/views/hooks/useContractBalance';
import { useHirerAccount } from 'src/app/v1/views/hooks/useHirerAccount';
import type { AppState } from 'src/types/appState';

export const useHirerAccountAndContractBalance = () => {
  const { advertiserNation, seekAdvertiserId, isDataCleanupComplete } =
    useSelector(
      (state: AppState) => ({
        advertiserNation: state.session.hirerAccount.nation,
        seekAdvertiserId: state.session.seekAdvertiserId,
        isDataCleanupComplete: state.app.isDataCleanupComplete,
      }),
      shallowEqual,
    );

  const { getContractBalanceLazyQuery, isLoading: isLoadingContractBalance } =
    useContractBalance();
  const { isLoading: isLoadingHirerAccount } = useHirerAccount();

  useEffect(() => {
    if (isDataCleanupComplete && seekAdvertiserId && advertiserNation) {
      getContractBalanceLazyQuery({
        variables: {
          advertiserId: seekAdvertiserId,
          advertiserNation,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seekAdvertiserId, isDataCleanupComplete, advertiserNation]);

  return { loading: isLoadingHirerAccount || isLoadingContractBalance };
};
